import ArrivalsOfShipsReception from "../../reception/ArrivalsOfShips";
import FireReportReception from "../../reception/FireReport";
import NotificationReception from "../../reception/Notifications";
import ReplacementCardsReception from "../../reception/ReplacementCards";
import SupportReception from "../../reception/Support";
import UnreturnedCardsReception from "../../reception/UnreturnedCards";
import WhiteListGuestsReception from "../../reception/WhiteList/WhiteListGuestsReception";

const useNavLinksArray = () => {
  const navLinksArrayPorter: navLinksArrayTimeWorkerInterface = {
    profileId: 6,
    routesArrayWithComponents: [],
    hidenInNavBar: [
      {
        ifHidden: false,
        path: "/reception/home",
        component: (props) => <NotificationReception {...props} />,
      },
      {
        ifHidden: false,
        path: "/reception/unreturned-cards",
        component: () => <UnreturnedCardsReception />,
      },
      {
        ifHidden: false,
        path: "/reception/fire-report",
        component: () => <FireReportReception />,
      },
      {
        ifHidden: false,
        path: "/reception/white-list",
        component: () => <WhiteListGuestsReception />,
      },
      {
        ifHidden: false,
        path: "/reception/replacement-cards",
        component: () => <ReplacementCardsReception />,
      },
      {
        ifHidden: false,
        path: "/reception/arrival-of-ships",
        component: () => <ArrivalsOfShipsReception />,
      },
      {
        ifHidden: false,
        path: "/reception/lists-of-employees",
        component: () => <SupportReception />,
      },
    ],
  };

  return navLinksArrayPorter;
};
export default useNavLinksArray;
